export const PROJECT_NOT_AVAILABLE_ERROR = 'PROJECT_NOT_AVAILABLE_ERROR' as const;
export const NETWORK_ERROR = 'NETWORK_ERROR' as const;
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR' as const;
